import { Component } from '@angular/core';
import { LOGO_IMAGE } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-logo',
  templateUrl: './landing-logo.component.html',
  styleUrls: ['./landing-logo.component.scss'],
})
export class LandingLogoComponent {
  readonly logoImage = LOGO_IMAGE;
}
